import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "components/CustomButtons/Button.js";
import DynamicInput from "components/DynamicInput/DynamicInput";

// @material-ui/icons
import Close from "@material-ui/icons/Close";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";

import { TitleModalStyled, SubtitleModalStyled } from "./styles";

import styles from "assets/jss/material-dashboard-pro-react/modalStyle.js";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ModalPrice = ({
  title = "Precio",
  color,
  colorRGB,
  isOpen,
  onCloseModal,
  item,
  price,
  onChangePrice,
  onSubmit,
  noIcon = false,
}) => {
  const classes = useStyles();
  return (
    <>
      <Dialog
        classes={{
          root: classes.center,
          paper: classes.modal,
        }}
        open={isOpen}
        transition={Transition}
        keepMounted
        onClose={() => onCloseModal()}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => onCloseModal("priceModal")}
          >
            <Close className={classes.modalClose} />
          </Button>
          <TitleModalStyled color={colorRGB} className={classes.modalTitle}>
            {title}
          </TitleModalStyled>
          <SubtitleModalStyled>
            {item ? item.product : "Producto"}
          </SubtitleModalStyled>
        </DialogTitle>
        <DialogContent
          id="modal-slide-description"
          className={classes.modalBody}
        >
          <DynamicInput
            id="material"
            color={color}
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              value: price,
              type: "number",
              onChange: (event) => onChangePrice(event),
              startAdornment: !noIcon && (
                <InputAdornment position="start">
                  <AttachMoneyIcon />
                </InputAdornment>
              ),
              color: "secondary",
            }}
          />
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button onClick={() => onCloseModal("priceModal")} color="danger">
            Cancelar
          </Button>
          <Button onClick={() => onSubmit(item, price)} color="success">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalPrice;
